<template>
    <div class="px-120 pb-40 text-[rgb(8,8,8)]" :class="[route.query.id === '782kzq4m' ? 'bg-#F6E4BE' : '']">
        <div class="mx-auto pt-36">
            <div class="flex justify-between mb-60">
                <div class="flex-shrink-0 w-280px">
                    <div @click="() => { router.push('/Home') }" :style="{
                        backgroundImage: `url(${getCurrentLocale === LocaleTypeEnum.English ? logoEn : logo})`,
                    }" :class="getCurrentLocale === LocaleTypeEnum.English ? '!w-96 !h-28' : '!w-120 !h-23'"
                        class="bg-no-repeat bg-left-center bg-contain mb-16 cursor-pointer"></div>
                    <div class="text-16 leading-22px text-[rgb(8,8,8)]">{{ t('footer.subtitle') }}</div>
                </div>

                <div class="flex gap-80 flex-1 justify-between ml-93">
                    <div v-for="(column, index) in navColumns" :key="index" class="flex flex-col gap-16">
                        <div class="text-18 font-500 text-#000 mb-8">{{ column.title }}</div>
                        <div v-for="link in column.links" :key="link.label"
                            class="text-14 relative flex w-fit  flex-center text-[rgba(8,8,8,0.6)] cursor-pointer hover:text-#3846FA transition-colors"
                            @click="jumpUrl(link?.link)">
                            {{ link.label }}
                            <div v-if="!link.link"
                                class=" rounded-2 ml-5 flex-center bg-[rgba(255,168,118,0.1)] h-fit font-700 text-[rgba(255,187,147,0.7)] text-12 px-5">
                                <span class=" skew-x--6">{{ t('common.comingSoon') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-between items-center pt-32 border-t-solid border-1 border-#DDE2E9">
                <div class="text-14 text-[rgba(8,8,8,0.4)]">
                    <span>{{ $t('footer.copyright') }}</span>
                    <a v-if="currentLocale !== LocaleTypeEnum.English" href="https://beian.miit.gov.cn/" target="_blank"
                        class="ml-20px no-underline hover:text-#000 transition-colors">
                        {{ $t('footer.icp') }}
                    </a>
                </div>

                <div class="flex gap-16 items-center">
                    <template v-for="item in socialIcons" :key="item.icon">
                        <el-tooltip v-if="item.tooltip" effect="light" placement="top">
                            <img class="w-32px h-32px cursor-pointer hover:opacity-80 transition-opacity"
                                :src="item.icon" />
                            <template #content>
                                <img class="size-180px" :src="item.tooltip" />
                            </template>
                        </el-tooltip>
                        <img v-else class="w-32px h-32px cursor-pointer hover:opacity-80 transition-opacity"
                            :src="item.icon" @click="jumpUrl(item?.link)" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { LocaleTypeEnum } from '@/store/locale';
import { useI18n } from 'vue-i18n';
import logoEn from '@/assets/svgs/logo-black-en.svg';
import logo from '@/assets/svgs/logo-black.svg';
import githubIcon from '@/assets/svgs/footer/github.svg';
import gitcodeIcon from '@/assets/svgs/footer/gitcode.svg';
import weixinIcon from '@/assets/svgs/footer/weixin-1.svg';
import bilibiliIcon from '@/assets/svgs/footer/bilibili.webp';
import zhihuIcon from '@/assets/svgs/footer/zhihu.svg';
import mailIcon from '@/assets/svgs/footer/mail.svg';
import linkedinIcon from '@/assets/svgs/footer/Linkedin.svg';
import youtubeIcon from '@/assets/svgs/footer/youtube.svg';
import xIcon from '@/assets/svgs/footer/X.svg';
import facebookIcon from '@/assets/svgs/footer/facebook.svg';
import weixinQrcode from '@/assets/imgs/weixin.jpg';
import feishuQrcode from '@/assets/imgs/feishu-qrcode.png';
import feishuicon from "@/assets/svgs/footer/feishu.svg"
import discordIcon from "@/assets/svgs/footer/discord.svg"

const { getCurrentLocale, currentLocale } = useStore('locale');
const { t } = useI18n();

const route = useRoute()

/** 文档地址语言段：中文 zh-cn / 英文 en（与 header「开源核心库」的地址保持一致） */
const docsLang = () => (getCurrentLocale.value === LocaleTypeEnum.English ? 'en' : 'zh-cn');
/** 生成项目的文档地址 */
const docsLink = (project: string) => `https://docs.flagos.io/projects/${project}/${docsLang()}/latest/`;

const navColumns = computed(() => [
    {
        title: t('footer.products'),
        links: [
            { label: 'FlagGems', link: docsLink('FlagGems') },
            // { label: 'FlagGems-vllm' },
            { label: 'FlagScale', link: docsLink('FlagScale') },
            { label: 'FlagTree', link: docsLink('FlagTree') },
            // { label: 'FlagTree-CPU' },
            { label: 'FlagCX', link: docsLink('FlagCX') },
        ],
    },
    {
        title: t('footer.developers'),
        links: [
            { label: 'FlagOS Skills', link: '/SkillHub' },
            { label: t('footer.onlineLab'), link: '/onlineLab' },
            { label: 'KernelGen', link: 'https://kernelgen.flagos.io/' },
            // { label: 'FlagRelease', link: '' },
            // { label: 'FlagCICD' },
            { label: t('footer.docsCenter'), link: getCurrentLocale.value === LocaleTypeEnum.English ? 'https://docs.flagos.io/en/latest/' : 'https://docs.flagos.io/zh-cn/latest/' },
        ],
    },
    {
        title: t('footer.community'),
        links: [
            { label: t('footer.contributorGuide'), link: '/contribution' },
            { label: t('common.events'), link: '/events?tab=competition' },
            { label: t('footer.blog'), link: 'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzkzNTc0NTg2OA==&action=getalbum&album_id=4505397820136505350&subscene=126&scenenote=https%3A%2F%2Fmp.weixin.qq.com%2Fs%3F__biz%3DMzkzNTc0NTg2OA%3D%3D%26mid%3D2247488263%26idx%3D1%26sn%3D58a54a965f3bc8444ebb2ccb7e2ba7a0%26chksm%3Dc3f9c63464ef8f6ff752c24a8d705eeae22417be79ace7bd9693e6342dbf1d5f1e2cc41dc986%26scene%3D126%26sessionid%3D0%26clicktime%3D1779442435%26enterid%3D1779442435%26ascene%3D3%26devicetype%3DiOS17.3.1%26version%3D18003c32%26nettype%3DWIFI%26abtest_cookie%3DAAACAA%253D%253D%26lang%3Den%26countrycode%3DCN%26fontScale%3D100%26exportkey%3Dn_ChQIAhIQm0Eg4EWFY8yKyt%252BEFn9BYBLeAQIE97dBBAEAAAAAAEOVNeUwViYAAAAOpnltbLcz9gKNyK89dVj0dLFgOrKj2bBxZdpzGyzZ2rVdQvGdigi0Y7Syhu2G8Tj%252FpzhlXhBwP5ksTU3GoN8ekocUslTG7RQeBRXI95QRWK6UlWwu7JBiTkEhFaE8lDPV476pM%252B70vWYznnNjZsH9iZhdCfebWnRTQ%252FisMJ2%252BYh6LhsfmtbsTVE96tjPfyIRfO5BXhkwoEPRNrrkYvgklQA97WwQnX6gIa%252BiWNvK5vxqnChVhx%252BqG3ySHLrTrr35oSazl7ZP4oQ%253D%253D%26pass_ticket%3DbRQ68imCCexwL67pMmO8Ou4SsLEHkDF0823QEa9dasw5nP5k5vkj9fZLR45LNfap%26wx_header%3D3&nolastread=1#wechat_redirect' }
        ],
    },
    {
        title: t('footer.about'),
        links: [
            { label: t('footer.flagOS'), link: '/About' },
            { label: t('footer.brand'), link: '/flagoslogo' },
            { label: t('footer.contactUs'), link: '/contact' },
            { label: t('footer.projectRecruitment'), link: '/projectRecruitment' },
        ],
    },
]);
watchEffect(() => {
    console.log(getCurrentLocale.value)
})
const router = useRouter();
const jumpUrl = (url: string, target?: string) => {
    if (!url) return;
    if (url.indexOf('?') === -1) {
        url += ('?' + (getCurrentLocale.value === 'en' ? 'lang=en' : 'lang=zh'))
    } else {
        url += ('&' + (getCurrentLocale.value === 'en' ? 'lang=en' : 'lang=zh'))
    }
    if (url.startsWith('/') && target !== '_blank') {
        router.push(url);
    } else {
        window.open(url);
    }
};
const socialIcons = [
    { icon: githubIcon, link: 'https://github.com/flagos-ai' },
    { icon: gitcodeIcon, link: 'https://gitcode.com/flagos-ai' },
    { icon: feishuicon, tooltip: feishuQrcode },
    { icon: weixinIcon, tooltip: weixinQrcode },
    { icon: bilibiliIcon, link: 'https://space.bilibili.com/3546791834290849' },
    { icon: zhihuIcon, link: 'https://www.zhihu.com/people/95-22-20-18/posts' },
    { icon: mailIcon, link: 'mailto:contact@flagos.io' },
    { icon: linkedinIcon, link: 'https://www.linkedin.com/company/flagos-community' },
    { icon: youtubeIcon, link: 'https://www.youtube.com/@FlagOS_Official' },
    { icon: xIcon, link: 'https://x.com/FlagOS_Official' },
    { icon: discordIcon, link: 'https://discord.com/invite/BwavgwVEkk' },
    { icon: facebookIcon, link: 'https://www.facebook.com/FlagOSCommunity' },
];
</script>
